import React from 'react';
import Responsive from 'react-responsive';

import { MEDIA_BREAKPOINTS } from '../../hooks';

export const Desktop = (props) => <Responsive {...props} {...MEDIA_BREAKPOINTS['desktop']} />;
export const AboveMobile = (props) => <Responsive {...props} {...MEDIA_BREAKPOINTS['aboveMobile']} />;
export const BelowDesktop = (props) => <Responsive {...props} {...MEDIA_BREAKPOINTS['belowDesktop']} />;
export const Tablet = (props) => <Responsive {...props} {...MEDIA_BREAKPOINTS['tablet']} />;
export const Mobile = (props) => <Responsive {...props} {...MEDIA_BREAKPOINTS['mobile']} />;
